module.exports = __webpack_public_path__ + "static/esa-ada1f89ee4de835b812ace21147347b4.png";